import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Mujeres listas para recuperar su poder', 'Quienes entienden que el silencio es un arma', 'Dispuestas a sentir incomodidad temporal por paz a largo plazo', 'Quienes valoran su dignidad por encima de la validación'];
const notForWho = ['Quienes buscan trucos para que él vuelva', 'Mujeres que prefieren la ilusión a la realidad', 'Quienes no están dispuestas a cortar el contacto', 'Adictas al drama y al ciclo de toxicidad'];
export function WhoIsThisFor() {
  return <section className="py-32 px-6 bg-charcoal-light relative border-t border-gold/10" data-id="element-268">
      <div className="max-w-6xl mx-auto" data-id="element-269">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24" data-id="element-270">
          {/* Column A: For Who */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="bg-card p-10 rounded-sm border border-gold/20" data-id="element-271">
            <h3 className="font-playfair text-3xl text-white mb-8 border-b border-white/10 pb-6" data-id="element-272">
              Para la mujer <span className="text-gold italic" data-id="element-273">soberana</span>
            </h3>
            <ul className="space-y-6" data-id="element-274">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-275">
                  <div className="flex-shrink-0 mt-1" data-id="element-276">
                    <Check className="w-5 h-5 text-gold" strokeWidth={2} data-id="element-277" />
                  </div>
                  <span className="font-sans text-gray-300 font-light leading-relaxed" data-id="element-278">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Column B: Not For Who */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="bg-charcoal p-10 rounded-sm border border-white/5 opacity-80" data-id="element-279">
            <h3 className="font-playfair text-3xl text-gray-400 mb-8 border-b border-white/5 pb-6" data-id="element-280">
              No para quien busca <span className="italic" data-id="element-281">rogar</span>
            </h3>
            <ul className="space-y-6" data-id="element-282">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-283">
                  <div className="flex-shrink-0 mt-1" data-id="element-284">
                    <X className="w-5 h-5 text-red-900/60" strokeWidth={2} data-id="element-285" />
                  </div>
                  <span className="font-sans text-gray-500 font-light leading-relaxed" data-id="element-286">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}